import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { useState } from "react";
import { Grid, Button, Divider, Typography, Tabs, Paper, Dialog, ListItem, DialogOpportunity, DialogContact, DialogPeople, DataTable, Create, Clear, AddCircleIcon, makeStyles, AccountCircleIcon, DialogComercialTask, SMPopover, DialogViewInvoice, RemoveRedEye } from "../../../../";
import selects from "../../../../assets/selects";
var useStyles = makeStyles(function (theme) {
  var _leftMain;

  return {
    root: {
      padding: "4px 25px"
    },
    leftMain: (_leftMain = {}, _defineProperty(_leftMain, theme.breakpoints.up("md"), {
      boxShadow: "15px 0 15px -5px #333"
    }), _defineProperty(_leftMain, "padding", "24px"), _defineProperty(_leftMain, "height", "100%"), _defineProperty(_leftMain, "overflowY", "scroll"), _leftMain),
    headerLeftMain: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    dataContact: {
      margin: "10px",
      display: "flex",
      "flex-direction": "column",
      "align-items": "left"
    },
    infoContact: {
      margin: "10px",
      display: "flex",
      "flex-direction": "column",
      "align-items": "left",
      flex: "1 1 auto"
    },
    contact: {
      background: "#ededed45",
      borderRadius: "4px"
    },
    headerContact: {
      display: "flex",
      "align-items": "center",
      justifyContent: "space-between"
    },
    actionsContact: {
      display: "flex",
      justifyContent: "flex-end",
      "max-width": "86%"
    },
    divider: {
      margin: "20px 0",
      height: "4px"
    },
    mr30: {
      margin: "30px"
    },
    icon: {
      width: "80px",
      height: "auto"
    },
    contactsUser: {
      display: "flex",
      overflowY: "scroll",
      height: "400px",
      "flex-direction": "column",
      "align-items": "left",
      "justify-content": "flex-start"
    },
    edit: {
      color: theme.palette.pending.main
    },
    header: {
      display: "flex",
      "flex-direction": "row",
      "justify-content": "space-between",
      "align-items": "center"
    },
    people_actions: {
      display: "flex",
      "& button": {
        "min-width": "30px"
      },
      flexDirection: "column",
      alignItems: "flex-end"
    },
    text_wrap: {
      "word-wrap": "break-word"
    }
  };
});

var ContactsSingle = function ContactsSingle(_ref) {
  var tasks = _ref.tasks,
      projects = _ref.projects,
      opportunities = _ref.opportunities,
      contact = _ref.contact,
      translation = _ref.translation,
      editContact = _ref.editContact,
      deleteContact = _ref.deleteContact,
      deletePeople = _ref.deletePeople,
      language = _ref.language,
      editPeople = _ref.editPeople,
      createPeople = _ref.createPeople,
      createOpportunity = _ref.createOpportunity,
      editTask = _ref.editTask,
      deleteTask = _ref.deleteTask,
      currency = _ref.currency,
      getInvoice = _ref.getInvoice,
      invoices = _ref.invoices,
      editStatus = _ref.editStatus,
      props = _objectWithoutProperties(_ref, ["tasks", "projects", "opportunities", "contact", "translation", "editContact", "deleteContact", "deletePeople", "language", "editPeople", "createPeople", "createOpportunity", "editTask", "deleteTask", "currency", "getInvoice", "invoices", "editStatus"]);

  // console.log("ContactsSingle tasks", tasks);
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openAddOpportunity = _useState2[0],
      setOpenAddOpportunity = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openEditContact = _useState4[0],
      setOpenEditContact = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openViewTask = _useState6[0],
      setViewTaskOpen = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      openEditTask = _useState8[0],
      setEditTaskOpen = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      openDeleteTask = _useState10[0],
      setDeleteTaskOpen = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      openPeople = _useState12[0],
      setOpenPeople = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      openDeleteContact = _useState14[0],
      setOpenDeleteContact = _useState14[1];

  var _useState15 = useState({}),
      _useState16 = _slicedToArray(_useState15, 2),
      selectedTask = _useState16[0],
      setSelectedTask = _useState16[1];

  var _useState17 = useState(""),
      _useState18 = _slicedToArray(_useState17, 2),
      variant = _useState18[0],
      setVariant = _useState18[1];

  var _useState19 = useState({
    people: [{
      name: "",
      job: "",
      email: "",
      telephone: "",
      type: "person"
    }]
  }),
      _useState20 = _slicedToArray(_useState19, 2),
      people = _useState20[0],
      setPeople = _useState20[1];

  var _useState21 = useState({}),
      _useState22 = _slicedToArray(_useState21, 2),
      deletedPeople = _useState22[0],
      setDeletePeople = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      openDeletePeople = _useState24[0],
      setOpenDeletePeople = _useState24[1];

  var classes = useStyles();

  var _useState25 = useState("invoices"),
      _useState26 = _slicedToArray(_useState25, 2),
      value = _useState26[0],
      setValue = _useState26[1];

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openView = _React$useState2[0],
      setOpenView = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      selectedInvoice = _React$useState4[0],
      setSelectedInvoice = _React$useState4[1];

  var handleViewInvoice = function handleViewInvoice(id) {
    if (!openView) {
      // const invoice = invoices.find(invoice => invoice._id === id);
      // console.log("handleItemViewInvoice invoice", invoice);
      getInvoice(id).then(function (response) {
        // console.log("handleViewInvoice", response.data);
        setSelectedInvoice(_objectSpread({}, response.data));
      });
    } else {
      setSelectedInvoice(null);
    }

    setOpenView(!openView);
  }; // eslint-disable-next-line no-unused-expressions


  translation ? translation.datatables ? translation.datatables.tasks ? translation.datatables.tasks.columns.find(function (column) {
    return column.name === "options";
  }) ? translation.datatables.invoices.columns.find(function (column) {
    return column.name === "options";
  }).options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return /*#__PURE__*/React.createElement(SMPopover, {
        "data-cy": "tasks-actions",
        data: tableMeta.rowData,
        type: "tasks",
        labels: [{
          label: translation.popovers.tasks.view,
          name: "view",
          onItemClick: handleItemDatatablePopover
        }, {
          label: translation.popovers.tasks.edit,
          name: "edit",
          onItemClick: handleItemDatatablePopover
        }, {
          label: translation.popovers.tasks["delete"],
          name: "delete",
          onItemClick: handleItemDatatablePopover
        }]
      });
    }
  } : null : null : null : null; // eslint-disable-next-line no-unused-expressions

  translation && translation.datatables && translation.datatables.invoices && translation.datatables.invoices.columns.find(function (column) {
    return column.name === "options";
  }) && (translation.datatables.invoices.columns.find(function (column) {
    return column.name === "options";
  }).options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return /*#__PURE__*/React.createElement(RemoveRedEye, {
        onClick: function onClick() {
          return handleViewInvoice(tableMeta.rowData[0]);
        }
      });
    }
  });

  var handleDialogAddOpportunity = function handleDialogAddOpportunity() {
    setOpenAddOpportunity(!openAddOpportunity);
  };

  var handleDialogEditContact = function handleDialogEditContact() {
    setOpenEditContact(!openEditContact);
  };

  var handleDialogPeople = function handleDialogPeople() {
    setOpenPeople(!openPeople);
  };

  var handleDialogDeleteContact = function handleDialogDeleteContact() {
    setOpenDeleteContact(!openDeleteContact);
  };

  var handleDialogDeletePeople = function handleDialogDeletePeople() {
    setOpenDeletePeople(!openDeletePeople);
  };

  var handleDialogViewTask = function handleDialogViewTask(id) {
    if (!openViewTask) {
      var task = tasks.find(function (task) {
        return task._id === id;
      });
      setSelectedTask(_objectSpread(_objectSpread({}, task), {}, {
        person_of_contact: task.contact._id
      }));
    } else {
      setSelectedTask({});
    }

    setViewTaskOpen(!openViewTask);
  };

  var handleDialogEditTask = function handleDialogEditTask(id) {
    if (!openEditTask) {
      var task = tasks.find(function (task) {
        return task._id === id;
      });
      setSelectedTask(_objectSpread(_objectSpread({}, task), {}, {
        person_of_contact: task.contact._id
      }));
    } else {
      setSelectedTask({});
    }

    setEditTaskOpen(!openEditTask);
  };

  var handleDialogDeleteTask = function handleDialogDeleteTask(id) {
    if (!openDeleteTask) {
      var task = tasks.find(function (task) {
        return task._id === id;
      });
      setSelectedTask(_objectSpread(_objectSpread({}, task), {}, {
        person_of_contact: task.contact._id
      }));
    } else {
      setSelectedTask({});
    }

    setDeleteTaskOpen(!openDeleteTask);
  };

  var handleCreateOpportunity = function handleCreateOpportunity(values) {
    createOpportunity(values);
  };

  var handleCreatePeople = function handleCreatePeople(values) {
    return createPeople(values);
  };

  var handleTabs = function handleTabs(event, newValue) {
    setValue(newValue);
  };

  var handleEditPeople = function handleEditPeople(person) {
    setVariant("edit");
    setPeople({
      people: [person]
    });
  };

  var contentTabHandler = function contentTabHandler(value) {
    // console.log('translationen contentTabHandler', translation.datatables)
    switch (value) {
      case "opportunities":
        return /*#__PURE__*/React.createElement(DataTable, {
          key: language + "_opportunities",
          type: "opportunities",
          data: opportunities,
          translation: translation ? translation.datatables.opportunities : null
        });

      case "projects":
        return /*#__PURE__*/React.createElement(DataTable, {
          key: language + "_projects",
          type: "projects",
          data: projects,
          translation: translation ? translation.datatables.projects : null
        });

      case "tasks":
        return /*#__PURE__*/React.createElement(DataTable, {
          key: language + "_tasks",
          type: "tasks",
          data: tasks,
          translation: translation ? translation.datatables.tasks : null
        });

      case "invoices":
        return /*#__PURE__*/React.createElement(DataTable, {
          key: language + "_invoices",
          data: invoices,
          translation: translation ? translation.datatables.invoices : null
        });

      default:
        return /*#__PURE__*/React.createElement(DataTable, {
          key: language + "_opportunities",
          type: "tasks",
          data: opportunities,
          translation: translation ? translation.datatables.opportunities : null
        });
    }
  };

  var handleItemDatatablePopover = function handleItemDatatablePopover(item, id) {
    if (item === "view") {
      handleDialogViewTask(id);
    } else if (item === "edit") {
      handleDialogEditTask(id);
    } else if (item === "delete") {
      handleDialogDeleteTask(id);
    }
  };

  return [/*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(DialogViewInvoice, {
    variant: "invoice-view",
    open: openView,
    editStatus: editStatus,
    onClose: function onClose() {
      setOpenView(false);
      setSelectedInvoice(null);
    },
    franchise: true,
    invoice: selectedInvoice,
    translation: translation ? translation.dialogs.view_invoice : null
  }), /*#__PURE__*/React.createElement(DialogOpportunity, {
    from: "contact-single",
    contact: contact._id,
    currency: currency,
    variant: "add",
    open: openAddOpportunity,
    onClose: handleDialogAddOpportunity,
    createOpportunity: handleCreateOpportunity,
    translation: translation ? translation.dialogs.add_opportunity : null
  }), /*#__PURE__*/React.createElement(DialogContact, {
    open: openEditContact,
    onClose: handleDialogEditContact,
    variant: "edit",
    translation: translation ? translation.dialogs.edit_contact : null,
    contact: contact,
    editContact: editContact
  }), /*#__PURE__*/React.createElement(DialogPeople, {
    open: openPeople,
    onClose: handleDialogPeople,
    variant: variant,
    people: people,
    editPeople: editPeople,
    translation: translation ? translation.dialogs.add_person_of_contact : null,
    createPeople: handleCreatePeople
  }), /*#__PURE__*/React.createElement(DialogComercialTask, {
    open: openViewTask,
    variant: "view",
    translation: translation ? translation.dialogs.add_task : null,
    onClose: handleDialogViewTask,
    task: selectedTask,
    peopleOfContact: contact ? contact.people : []
  }), /*#__PURE__*/React.createElement(DialogComercialTask, {
    open: openEditTask,
    variant: "edit",
    translation: translation ? translation.dialogs.add_task : null,
    onClose: handleDialogEditTask,
    editTask: editTask,
    task: selectedTask,
    peopleOfContact: contact ? contact.people : []
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openDeleteContact,
    onClose: handleDialogDeleteContact,
    id: "modal-confirm-delete-contact",
    title: translation ? translation.dialogs.delete_contact.titles.delete_contact : null,
    text: translation ? translation.dialogs.delete_contact.info : null,
    submit: translation ? translation.dialogs.delete_contact.buttons["delete"] : null,
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleDialogDeleteContact,
    cancel: translation ? translation.dialogs.delete_contact.buttons.cancel : null,
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      deleteContact();
      handleDialogDeleteContact();
    }
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openDeleteTask,
    onClose: handleDialogDeleteTask,
    id: "modal-confirm-delete-task",
    title: translation && translation.dialogs.delete_task ? translation.dialogs.delete_task.title : null,
    text: translation && translation.dialogs.delete_task ? translation.dialogs.delete_task.info : null,
    submit: translation && translation.dialogs.delete_task ? translation.dialogs.delete_task.buttons["delete"] : null,
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleDialogDeleteTask,
    cancel: translation && translation.dialogs.delete_task ? translation.dialogs.delete_task.buttons.cancel : null,
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      deleteTask(selectedTask);
      handleDialogDeleteTask();
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3,
    xs: 12,
    style: {
      paddingBottom: "10px",
      height: "100vh"
    }
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.leftMain
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerContact
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerLeftMain
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, contact ? contact.name : "Loading...")), /*#__PURE__*/React.createElement("div", {
    className: classes.actionsContact
  }, /*#__PURE__*/React.createElement(Button, {
    "data-cy": "edit-contact",
    className: [classes.edit].join(" "),
    color: "default",
    variant: "text",
    onClick: handleDialogEditContact
  }, /*#__PURE__*/React.createElement(Create, null)), /*#__PURE__*/React.createElement(Button, {
    "data-cy": "delete-contact",
    color: "secondary",
    variant: "text",
    onClick: handleDialogDeleteContact
  }, /*#__PURE__*/React.createElement(Clear, null)))), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.dataContact
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.contact_info.titles.billing_info_name : "Tax names"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.text_wrap
  }, contact ? contact.social_reason : " "), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.contact_info.titles.contact_email : "Email"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.text_wrap
  }, contact ? contact.email : " ", " "), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.contact_info.titles.contact_phone : "Phone number"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.text_wrap
  }, contact ? contact.telephone : " ", " "), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.contact_info.titles.contact_city : "City"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.text_wrap
  }, contact ? contact.city : "", " "), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.contact_info.titles.contact_type : "Client type"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.text_wrap
  }, translation && contact.clientType ? translation.client_type.find(function (type) {
    return contact.clientType === type.value;
  }).label : selects && contact.clientType ? selects.client_type.find(function (type) {
    return contact.clientType === type.value;
  }) : null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary",
    className: classes.text_wrap
  }, translation ? translation.contact_info.titles.contact_web : "Web"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.text_wrap
  }, contact && contact.web), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "primary"
  }, translation ? translation.contact_info.people_of_contact.titles.people_of_contact : "People of contact"), /*#__PURE__*/React.createElement(Button, {
    className: classes.add,
    color: "default",
    variant: "text",
    onClick: function onClick() {
      setVariant("add");
      handleDialogPeople();
    },
    "data-cy": "add-people"
  }, /*#__PURE__*/React.createElement(AddCircleIcon, null))), /*#__PURE__*/React.createElement("div", {
    className: classes.contactsUser
  }, contact && contact.people ? contact.people.map(function (person) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: "8px"
      }
    }, /*#__PURE__*/React.createElement(ListItem, {
      className: classes.contact
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      justify: "center",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2
    }, /*#__PURE__*/React.createElement(AccountCircleIcon, null)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 8,
      style: {
        display: "flex",
        flexDirection: "column"
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text_wrap
    }, person.name), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.text_wrap
    }, person.email), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.text_wrap
    }, person.telephone ? "".concat(person.telephone) : ""), person.job && /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      className: classes.text_wrap
    }, person.job)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2,
      className: classes.people_actions
    }, /*#__PURE__*/React.createElement(Button, {
      className: classes.add,
      color: "default",
      variant: "text",
      onClick: function onClick() {
        handleEditPeople(person);
        handleDialogPeople();
      },
      "data-cy": "edit-people"
    }, /*#__PURE__*/React.createElement(Create, null)), /*#__PURE__*/React.createElement(Button, {
      "data-cy": "delete-people",
      className: classes.add,
      color: "default",
      variant: "text",
      onClick: function onClick() {
        setDeletePeople(person._id);
        handleDialogDeletePeople();
      }
    }, /*#__PURE__*/React.createElement(Clear, null)), /*#__PURE__*/React.createElement(Dialog, {
      "data-cy": "modal-delete-contact",
      open: openDeletePeople,
      onClose: function onClose() {
        setDeletePeople("");
        handleDialogDeletePeople();
      },
      onCancel: function onCancel() {
        setDeletePeople("");
        handleDialogDeletePeople();
      },
      id: "modal-confirm-delete-person-of-contact",
      title: translation.dialogs.delete_person_of_contact.titles.delete_contact,
      text: translation.dialogs.delete_person_of_contact.info,
      submit: translation.dialogs.delete_person_of_contact.buttons["delete"],
      buttonColorSubmit: "secondary",
      buttonVariantSubmit: "contained",
      cancel: translation.dialogs.delete_person_of_contact.buttons.cancel,
      buttonColorCancel: "secondary",
      buttonVariantCancel: "outlined",
      onSubmit: function onSubmit() {
        deletePeople(deletedPeople);
        handleDialogDeletePeople();
      }
    })))));
  }) : null))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 9,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justify: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: value,
    onChange: handleTabs,
    variant: "standard",
    indicatorColor: "primary",
    textColor: "primary",
    contentTabs: translation.tabs ? translation.tabs : [// {
    //   label: "Opportunities",
    //   value: "opportunities"
    // },
    // {
    //   label: "Proyects",
    //   value: "projects"
    // },
    // {
    //   label: "Tasks",
    //   value: "tasks"
    // },
    {
      label: "Invoices",
      value: "invoices"
    }]
  }), contentTabHandler(value)))))];
};

export default ContactsSingle;